import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicFileInput } from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';
import _ from 'lodash';
function FacilityCreateTemplate({ editView }) {
    const {
        contentLoading,
        form,
        missingItems,
        facilitiesNeedingPayers
    } = editView;

    const missingItemsComp = [];
    _.each(missingItems, (val, key) => {
        const mItem = <div>
            <p>{_.toUpper(key)}:</p>
            <p>{_.join(val, '; ')}</p>
        </div>
        missingItemsComp.push(mItem);
    })

    return (
        <ApplicationEditLayout store={editView}>
            <Content loading={contentLoading} >
                <div className="row">
                    <div className="col col-sml-12 col-lrg-8">
                        <div className="card card--form card--primary card--med">
                            {/* <div className="card card--outlined--featured card--outlined--note card--xsml card--flex u-mar--bottom--med">
                                <div className="u-flex--space-between">
                                    <div>
                                        <i className="u-icon u-icon--sml u-icon--warning-triangle u-mar--right--sml"></i>
                                        Updating Coverage Types for Areas of Care will update all templates.
                                    </div>
                                </div>
                            </div> */}
                            <div className="row">
                                <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                                    <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                        <BasicFileInput field={form.$('file')} />
                                    </div>
                                </div>
                            </div>
                            {missingItems &&
                                <React.Fragment>
                                    <h4>Missing Items:</h4>
                                    <div>{missingItemsComp}</div>
                                </React.Fragment>
                            }
                            {facilitiesNeedingPayers &&
                                <React.Fragment>
                                    <div className='form__group__label'>Facility Insurance:</div>
                                    <div className="input input--textarea input--pre input--disabled">
                                        {facilitiesNeedingPayers.join('\n')}
                                    </div>
                                </React.Fragment>
                            }
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    )
}

FacilityCreateTemplate.propTypes = {
    editView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityCreateTemplate);
